import ActivityCard from "components/ActivityPanel/ActivityCard";
import React from "react";

interface Props {
  activity: server.dto.CostCenterActivity
}

const CostCenterActivityCard = (props: Props) => {
  const { activity } = props;

  return <ActivityCard
    activity={activity}
  >
  </ActivityCard>;
};

export default CostCenterActivityCard;